<template>
  <div>
    <el-dialog title="导出" :visible.sync="captchaModal" :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
      <div style="display: flex; align-items: center">
        <el-input
          v-model="captchCode"
          placeholder="请输入图形验证码"
          style="width: 200px"
        />
        <img :src="captchUrl" alt="0" style="width: 80px; margin-left: 30px" />
        <span
          @click="changeCaptch"
          style="cursor: pointer; margin-left: 10px; color: #999"
          >看不清楚，换一张</span
        >
      </div>
      <div
        v-if="!captchChecked"
        style="color: red; position: absolute; top: 108px; left: 18px"
      >
        验证码不正确
      </div>
      <span slot="footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <export-list ref="exportList"></export-list>
  </div>
</template>
<script>
import ExportList from './ExportList.vue'
import request, { baseURL } from '@/api/request'
import { getToken } from '@/api/util'
export default {
  data() {
    return {
      captchaModal: false,
      captchCode: '',
      captchChecked: true,
      captchUrl: '',
      baseUrl: '',
      params: '',
      serviceId: '',
      requestType: '',
      requestUrl: '',
      fileName: '',
      firstPay: ''
    }
  },
  components: {
    ExportList
  },
  mounted() {
    this.baseUrl = baseURL
  },
  methods: {
    init(params, serviceId, requestUrl, requestType, fileName) {
      this.captchUrl =
        `${this.baseUrl}/auth/export/kaptcha?t=${new Date().getTime()}` +
        '&access_token=' +
        getToken()
      this.captchaModal = true
      this.params = params
      this.serviceId = serviceId
      this.requestUrl = requestUrl
      this.requestType = requestType
      this.fileName = fileName
      this.captchCode = ''
      /* this.firstPay = firstPay || ''; */
    },
    handleExport() {
      this.captchUrl =
        `${this.baseUrl}/auth/export/kaptcha?t=${new Date().getTime()}` +
        '&access_token=' +
        getToken()
      this.captchaModal = true
    },
    changeCaptch() {
      this.captchUrl =
        `${this.baseUrl}/auth/export/kaptcha?t=${new Date().getTime()}` +
        '&access_token=' +
        getToken()
    },
    handleConfirm() {
      request({
        url: '/auth/export/checkDcyzm?access_token=' + getToken(),
        data: { yzm: this.captchCode },
        method: 'post'
      }).then((res) => {
        if (res.code == 0) {
          this.captchaModal = false
          let data = {
            params: JSON.stringify(this.params),
            serviceId: this.serviceId,
            requestUrl: this.requestUrl,
            requestType: this.requestType,
            fileName: this.fileName
          }
          /* if (this.firstPay) {
            data['firstPay'] = this.firstPay;
          } */
          request({
            url: 'admin/file/adm/fileExportAsync/addExportTask',
            data: data,
            method: 'post'
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: '导出已发起',
                type: 'success'
              })
              this.$refs.exportList.init()
            }
          })
        } else {
          this.$message.error('验证码错误')
        }
      })
    },
    handleCancel() {
      this.captchaModal = false
    }
  }
}
</script>
